<template>
    <p-search-screen
        title="Product Variants"
        api-destination="productvariant"
        edit-key="productVariantId"
        :filters="filters"
        :fields="fields"
        :filterBy="filterBy"
        :show-set-to="false"
        :use-is-active-checkbox="false"
        add-new-button
    >
        <template v-slot:actionButtons>
            <router-link to="/variantsortorder" class="btn btn-outline-primary">
                Variant Sort Order
            </router-link>
        </template>
        <template v-slot:belowSearch>
            <b-row>
                <b-col>
                <p-checkbox
                    label="Active"
                    v-model="filters.active"
                />
                <p-checkbox
                    label="Inactive"
                    v-model="filters.inactive"
                />
                </b-col>
            </b-row>
        </template>
    </p-search-screen>
</template>

<script>
import SearchStorage from '@/components/mixins/SearchFilterStorage.js';
export default {
    mixins: [SearchStorage],
    data() {
        return {
            filterName: 'ProductVariantFilter',
            filters: {
                automatic: '',
                perPage: 100,
                sortBy: 'sortOrder',
                sortDesc: true,
                searchBy: 'Variant Name',
                active: true,
                inactive: false
            },
            filterBy: ['All', 'Variant Name'],
            fields: [
                {
                    key: 'variantName',
                    label: 'Variant Name',
                    sortable: true
                },
                {
                    key: 'category',
                    sortable: true,
                    label: 'Category'
                },
                {
                    key: 'status',
                    label: 'Status',
                    sortable: true
                },
                {
                    key: 'sortOrder',
                    label: 'Sort Order',
                    sortable: true
                }
            ]
        };
    },
    methods: {}
};
</script>
